import { Field } from 'formik';
import { FormControl } from '../../../../shared/components/FormControl/FormControl';
import { Card } from '../../../../card/Card';
import { PipelineSettingsFormFields } from '../../interfaces/pipeline-settings-form-state';
import { FormikAsyncValidatedTextField } from '../../../../input/FormikAsyncValidatedTextField/FormikAsyncValidationTextField';

export function PipelineSetup({
  disabled,
  isEditing
}: {
  disabled?: boolean;
  isEditing?: boolean;
}) {
  return (
    <Card gridColumns={2} title='Pipeline Setup' dataId='pipeline-setup'>
      <div className='grid-column-span-1'>
        <FormControl>
          <Field
            name={PipelineSettingsFormFields.PIPELINE_NAME}
            component={FormikAsyncValidatedTextField}
            label='Pipeline Name'
            placeholder='Pipeline Name'
            required
            maxLength={255}
            disabled={disabled}
          />
        </FormControl>
      </div>

      <div className='grid-column-span-1'>
        <FormControl>
          <Field
            name={PipelineSettingsFormFields.DESTINATION_PREFIX}
            component={FormikAsyncValidatedTextField}
            label='Destination Prefix'
            placeholder='Destination Prefix'
            required
            disabled={disabled || isEditing}
            maxLength={255}
          />
        </FormControl>
      </div>
    </Card>
  );
}
